import React from 'react'

import {
  StyleSheet,
  View,
  ScrollView,
  Text
} from 'react-native'

import {
  adaptive, typography, colors
} from '@sart/styles'
import {
  Space,
  MoonDial,
  BalanceItem
} from '@sart/components'
import { useContent } from '@sart/content'
import client from '@sart/client'
import { Mobile } from '@sart/icons'

export default function PostpaidMinutes(props) {
  // const { navigation } = props
  const content = useContent()

  const {
    cache: {
      postpaidBalances,
			contextService,
			language
    } = {}
  } = client

  function getBalanceQuantity(balances) {
    if (balances && balances.voice && balances.voice.quantity) {
      return parseInt(balances.voice.quantity)
    }
    return 0
  }

  function getBalanceStartingQuantity(balances) {
    if(balances && balances.voice && balances.voice.startingQuantity) {
      return parseInt(balances.voice.startingQuantity)
    }
    return 0
  }

  return (
    <ScrollView
      style={styles.container}
    >
      <View style={styles.wrapper} >
        {contextService &&
					<View>
						<Space height={12} />
						<View style={styles.numberContainer}>
								<Mobile color={colors.white} height={26} width={11}/>
								<Space width={10} />
								<Text style={styles.numberText}>{contextService.lineIdentifier}</Text>
						</View>
						<Space height={12} />
					</View>
        }
        <View style={styles.dial}>
          <MoonDial
            name={content.dashboard.minutes}
            size={192}
            value={getBalanceQuantity(postpaidBalances)}
            range={getBalanceStartingQuantity(postpaidBalances)}
            style={styles.moondialStyle}
            strokeColour={colors.brightOrange + 20}
            mostlyFullColour={colors.brightOrange}
            almostEmptyColour={colors.brightOrange}
            mostlyFullTextColour={colors.white}
            almostEmptyTextColour={colors.white}
            textColour={colors.white}
						injectedContent={content}
          />
        </View>
        <Space height={24} />
        {postpaidBalances.voiceBreakdown && postpaidBalances.voiceBreakdown.map((balance, i) =>
          <React.Fragment key={i}>
            <BalanceItem
              iconColor={colors.white}
              placeholderStyle={styles.balanceItem}
              balance={balance}
							language={language}
							injectedContent={content}
            />
            <Space height={24} />
          </React.Fragment>
        )}
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    ...adaptive.wrapperPadding,
  },
  wrapper: {
    paddingBottom:12
  },
  dial: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  moondialStyle: {
    ...typography.lightbold
  },
  balanceItem: {
    backgroundColor: colors.darkCharcoal
  },
  moondialTextStyle: {
    ...typography.lightbold,
    color: colors.white
  },
  numberText: {
    textAlign: 'center',
    ...typography.extrabold,
    fontSize: 20,
    color: colors.white
  },
	numberContainer: {
			flexDirection: 'row',
			justifyContent: 'center',
	}
})


